<template>
  <div class="funds-governance w100 h100">
    <div class="filter_row">
      <a-form :model="filterConditions">
        <a-row type="flex">
          <div style="flex: 1">
            <a-row class="media-choice">
              <a-col :span="5">
                <a-form-item :wrapper-col="{ span: 24 }">
                  <a-select v-model:value="filterConditions.agentId" placeholder="请选择代理商" allow-clear show-search option-filter-prop="label" style="width: 100%" @change="onSearchBtnClick">
                    <a-select-option v-for="item in agentOptions" :key="item.agentId" :value="item.agentId" :label="item.label">{{ item.label }}</a-select-option>
                  </a-select>
                </a-form-item>
              </a-col>
              <a-col :span="3">
                <a-form-item :wrapper-col="{ span: 24 }">
                  <a-select v-model:value="filterConditions.exchangeType" placeholder="请选择置换类型" allow-clear style="width: 100%">
                    <a-select-option value="预付转授信">预付转授信</a-select-option>
                    <a-select-option value="授信转预付">授信转预付</a-select-option>
                    <a-select-option value="无消耗退款">无消耗退款</a-select-option>
                    <a-select-option value="低消耗退款">低消耗退款</a-select-option>
                  </a-select>
                </a-form-item>
              </a-col>
              <a-col :span="3">
                <a-form-item :wrapper-col="{ span: 24 }">
                  <a-select v-model:value="filterConditions.status" placeholder="请选择状态" allow-clear style="width: 100%">
                    <a-select-option value="PENDING">待执行</a-select-option>
                    <a-select-option value="PROCESSING">执行中</a-select-option>
                    <a-select-option value="OUT_SUCCESS">转出完成</a-select-option>
                    <a-select-option value="PARTIAL_SUCCESS">转入失败</a-select-option>
                    <a-select-option value="SUCCESS">成功</a-select-option>
                    <a-select-option value="FAILED">失败</a-select-option>
                    <a-select-option value="INVALID">已作废</a-select-option>
                  </a-select>
                </a-form-item>
              </a-col>
              <a-col :span="3">
                <a-form-item :wrapper-col="{ span: 24 }">
                  <a-input v-model:value="filterConditions.batchNo" placeholder="批次号" @press-enter="onSearchBtnClick"></a-input>
                </a-form-item>
              </a-col>
              <a-col :span="3">
                <a-form-item :wrapper-col="{ span: 24 }">
                  <a-input-number v-model:value="filterConditions.minExchangeAmount" placeholder="置换金额≥" :min="0" :precision="2" style="width: 100%" @press-enter="onSearchBtnClick" />
                </a-form-item>
              </a-col>
              <a-col :span="3">
                <a-form-item :wrapper-col="{ span: 24 }">
                  <a-date-picker v-model:value="filterConditions.startDate" placeholder="开始日期" style="width: 100%" value-format="YYYY-MM-DD" />
                </a-form-item>
              </a-col>
              <a-col :span="3">
                <a-form-item :wrapper-col="{ span: 24 }">
                  <a-date-picker v-model:value="filterConditions.endDate" placeholder="结束日期" style="width: 100%" value-format="YYYY-MM-DD" />
                </a-form-item>
              </a-col>
            </a-row>
          </div>
          <a-space>
            <a-button type="primary" @click="onSearchBtnClick" :disabled="tableLoading">筛选</a-button>
            <a-button @click="resetFilter" :disabled="tableLoading">重置</a-button>
          </a-space>
        </a-row>
      </a-form>
    </div>

    <div class="table_wrapper">
      <a-space :size="10" class="table_operation">
        <a-button  type="primary" @click="openGovernanceModal">资金预计算及治理</a-button>
        <a-button @click="openV2Modal">文件治理</a-button>
        <a-button  :disabled="selectedRows.length === 0" @click="executeSelected">选中治理</a-button>
        <a-button :loading="exportLoading" @click="exportRecord">导出</a-button>
        <!--<a-button  @click="openConditionModal">条件治理</a-button>-->
      </a-space>

      <a-table
        class="governance_table w100"
        size="small"
        bordered
        :row-key="(record, index) => index"
        :columns="tableColumns"
        :data-source="tableData"
        :loading="tableLoading"
        :pagination="tablePagination"
        :scroll="{ x: 'max-content', y: 'calc(100vh - 300px)' }"
        :row-selection="{ selectedRowKeys: selectedRowKeys, onChange: onSelectChange, getCheckboxProps: record => ({ disabled: record.status !== 'PENDING' }) }"
        @change="onTableChange"
      >
        <template #status="{ record }">
          <a-tag :color="statusColorMap[record.status]">{{ statusTextMap[record.status] || record.status }}</a-tag>
        </template>
        <template #remark="{ text }">
          <a-tooltip placement="topLeft" :mouse-enter-delay="0.3">
            <template #title>{{ text }}</template>
            <span class="cell-ellipsis">{{ text || '-' }}</span>
          </a-tooltip>
        </template>
      </a-table>
    </div>

    <!-- 执行资金治理弹窗 -->
    <a-modal
      v-model:visible="governanceModalVisible"
      title="资金预计算及治理"
      width="700px"
      :confirm-loading="governanceLoading"
      :ok-text="governanceResultText ? '关闭' : '确认执行'"
      :cancel-text="governanceResultText ? undefined : '取消'"
      :ok-button-props="governanceResultText ? {} : undefined"
      @ok="handleGovernanceOk"
      @cancel="handleGovernanceCancel"
    >
      <div v-if="!governanceResultText">
        <a-form :model="governanceForm" layout="vertical">
          <a-form-item label="代理商账号">
            <a-select
              v-model:value="governanceForm.agentIds"
              mode="multiple"
              placeholder="请选择代理商账号（留空表示全部）"
              allow-clear
              show-search
              option-filter-prop="label"
              style="width: 100%"
            >
              <a-select-option v-for="item in agentOptions" :key="item.agentId" :value="item.agentId" :label="item.label">{{ item.label }}</a-select-option>
            </a-select>
          </a-form-item>
          <a-form-item label="置换类型">
            <a-select
              v-model:value="governanceForm.exchangeTypes"
              mode="multiple"
              placeholder="请选择置换类型（留空表示全部）"
              allow-clear
              style="width: 100%"
            >
              <a-select-option value="预付转授信">预付转授信</a-select-option>
              <a-select-option value="授信转预付">授信转预付</a-select-option>
              <a-select-option value="无消耗退款">无消耗退款</a-select-option>
              <a-select-option value="低消耗退款">低消耗退款</a-select-option>
            </a-select>
          </a-form-item>
          <a-form-item>
            <a-checkbox v-model:checked="governanceForm.autoExecute">自动执行（不勾选则仅预计算）</a-checkbox>
          </a-form-item>
        </a-form>
      </div>
      <div v-else>
        <a-alert :message="governanceResultText" :type="governanceResultType" show-icon style="margin-bottom: 12px" />
        <p style="color: #999; font-size: 13px;">关闭后可查看治理记录列表确认执行情况</p>
      </div>
    </a-modal>

    <!-- 条件治理弹窗 -->
    <a-modal
      v-model:visible="conditionModalVisible"
      title="条件治理"
      width="600px"
      :confirm-loading="conditionLoading"
      :ok-text="conditionAuditData ? '确认执行' : '确定'"
      :ok-button-props="{ disabled: !conditionAuditData }"
      @ok="handleConditionOk"
      @cancel="handleConditionCancel"
    >
      <a-form :model="conditionForm" layout="vertical">
        <a-form-item label="代理商账号" required>
          <a-select
            v-model:value="conditionForm.agentId"
            placeholder="请选择代理商账号"
            allow-clear
            show-search
            option-filter-prop="label"
            style="width: 100%"
            @change="onConditionFieldChange"
          >
            <a-select-option v-for="item in agentOptions" :key="item.agentId" :value="item.agentId" :label="item.label">{{ item.label }}</a-select-option>
          </a-select>
        </a-form-item>
        <a-form-item label="置换类型" required>
          <a-select
            v-model:value="conditionForm.exchangeType"
            placeholder="请选择置换类型"
            allow-clear
            style="width: 100%"
            @change="onConditionFieldChange"
          >
            <a-select-option value="预付转授信">预付转授信</a-select-option>
            <a-select-option value="授信转预付">授信转预付</a-select-option>
            <a-select-option value="无消耗退款">无消耗退款</a-select-option>
            <a-select-option value="低消耗退款">低消耗退款</a-select-option>
          </a-select>
        </a-form-item>
      </a-form>
      <div v-if="conditionAuditLoading" style="text-align: center; padding: 16px 0;">
        <a-spin tip="正在预审核..." />
      </div>
      <div v-else-if="conditionAuditData">
        <a-descriptions bordered size="small" :column="1">
          <a-descriptions-item label="批次号">{{ conditionAuditData.batchNo }}</a-descriptions-item>
          <a-descriptions-item label="置换总金额">{{ conditionAuditData.totalAmount }}</a-descriptions-item>
          <a-descriptions-item label="总账户数">{{ conditionAuditData.countNo }}</a-descriptions-item>
        </a-descriptions>
      </div>
      <div v-else-if="conditionAuditError">
        <a-alert :message="conditionAuditError" type="error" show-icon />
      </div>
    </a-modal>

    <!-- 文件治理V2弹窗 -->
    <a-modal
      v-model:visible="v2ModalVisible"
      title="文件治理"
      width="700px"
      :confirm-loading="v2Loading"
      :ok-text="v2ResultText ? '关闭' : '确认执行'"
      :cancel-text="v2ResultText ? undefined : '取消'"
      @ok="handleV2Ok"
      @cancel="handleV2Cancel"
    >
      <div v-if="!v2ResultText">
        <a-form layout="vertical">
          <a-form-item label="账户余额文件（必填）" required>
            <a-upload-dragger
              :file-list="v2Form.accountBalanceFileList"
              :before-upload="file => beforeV2Upload(file, 'accountBalanceFile')"
              @remove="() => handleV2FileRemove('accountBalanceFile')"
              accept=".xlsx,.xls"
              :max-count="1"
            >
              <p class="ant-upload-drag-icon" style="margin-bottom: 4px">
                <inbox-outlined />
              </p>
              <p class="ant-upload-text" style="font-size: 13px">点击或拖拽Excel文件到此区域</p>
            </a-upload-dragger>
          </a-form-item>
          <a-form-item label="转账加款记录文件（选填）">
            <a-upload-dragger
              :file-list="v2Form.transferAddFileList"
              :before-upload="file => beforeV2Upload(file, 'transferAddFile')"
              @remove="() => handleV2FileRemove('transferAddFile')"
              accept=".xlsx,.xls"
              :max-count="1"
            >
              <p class="ant-upload-drag-icon" style="margin-bottom: 4px">
                <inbox-outlined />
              </p>
              <p class="ant-upload-text" style="font-size: 13px">点击或拖拽Excel文件到此区域</p>
            </a-upload-dragger>
          </a-form-item>
          <a-form-item label="转账退款记录文件（选填）">
            <a-upload-dragger
              :file-list="v2Form.transferRefundFileList"
              :before-upload="file => beforeV2Upload(file, 'transferRefundFile')"
              @remove="() => handleV2FileRemove('transferRefundFile')"
              accept=".xlsx,.xls"
              :max-count="1"
            >
              <p class="ant-upload-drag-icon" style="margin-bottom: 4px">
                <inbox-outlined />
              </p>
              <p class="ant-upload-text" style="font-size: 13px">点击或拖拽Excel文件到此区域</p>
            </a-upload-dragger>
          </a-form-item>
          <a-form-item label="置换类型">
            <a-select
              v-model:value="v2Form.exchangeTypes"
              mode="multiple"
              placeholder="请选择置换类型（留空表示全部）"
              allow-clear
              style="width: 100%"
            >
              <a-select-option value="预付转授信">预付转授信</a-select-option>
              <a-select-option value="授信转预付">授信转预付</a-select-option>
              <a-select-option value="无消耗退款">无消耗退款</a-select-option>
              <a-select-option value="低消耗退款">低消耗退款</a-select-option>
            </a-select>
          </a-form-item>
          <a-form-item>
            <a-checkbox v-model:checked="v2Form.autoExecute">自动执行（不勾选则仅预计算）</a-checkbox>
          </a-form-item>
        </a-form>
      </div>
      <div v-else>
        <a-alert :message="v2ResultText" :type="v2ResultType" show-icon style="margin-bottom: 12px" />
        <p style="color: #999; font-size: 13px;">关闭后可查看治理记录列表确认执行情况</p>
      </div>
    </a-modal>
  </div>
</template>

<script>
import { message, Modal } from 'ant-design-vue';
import { InboxOutlined } from '@ant-design/icons-vue';
import {
  queryFinancialGovernanceRecord,
  financialGovernance,
  financialGovernanceV2,
  executeFinancialGovernance,
  auditFinancialGovernance,
  exportGovernanceRecord,
} from '@/api/funds/governance.js';

export default {
  components: { InboxOutlined },
  data() {
    return {
      tableLoading: false,
      governanceLoading: false,
      exportLoading: false,
      tableData: [],
      selectedRowKeys: [],
      selectedRows: [],
      filterConditions: {
        agentId: null,
        exchangeType: undefined,
        status: undefined,
        batchNo: '',
        minExchangeAmount: null,
        startDate: null,
        endDate: null,
      },
      tablePagination: {
        current: 1,
        pageSize: 30,
        total: 0,
        showTotal: total => `总计${total}条数据`,
        showSizeChanger: true,
        pageSizeOptions: ['30', '50', '100', '500','1000','2000'],
      },
      statusColorMap: {
        PENDING: 'orange',
        PROCESSING: 'blue',
        OUT_SUCCESS: 'cyan',
        PARTIAL_SUCCESS: 'volcano',
        SUCCESS: 'green',
        FAILED: 'red',
        INVALID: 'default',
      },
      statusTextMap: {
        PENDING: '待执行',
        PROCESSING: '执行中',
        OUT_SUCCESS: '转出完成，等待转入',
        PARTIAL_SUCCESS: '转入失败，需人工补偿',
        SUCCESS: '成功',
        FAILED: '失败',
        INVALID: '已作废',
      },
      capitalTypeMap: {
        CREDIT_BIDDING: '授信竞价',
        CREDIT_BRAND: '授信品牌',
        CREDIT_GENERAL: '授信通用',
        PREPAY_BIDDING: '预付竞价',
        PREPAY_BRAND: '预付品牌',
        PREPAY_GENERAL: '预付通用',
      },
      tableColumns: [
        {
          title: '序号',
          key: 'index',
          width: 60,
          fixed: 'left',
          customRender: ({ index }) => (this.tablePagination.current - 1) * this.tablePagination.pageSize + index + 1,
        },
        {
          title: '批次号',
          dataIndex: 'batchNo',
          key: 'batchNo',
          width: 100,
          fixed: 'left',
        },
        {
          title: '账户ID',
          dataIndex: 'advertiserId',
          key: 'advertiserId',
          width: 100,
          fixed: 'left',
        },
        {
          title: '代理商ID',
          dataIndex: 'agentId',
          key: 'agentId',
          width: 100,
          fixed: 'left',
        },
        {
          title: '代理商名称',
          dataIndex: 'agentName',
          key: 'agentName',
          width: 130,
          fixed: 'left',
        },
        {
          title: '代理商-预付余额',
          dataIndex: 'agentPrepayBalance',
          key: 'agentPrepayBalance',
          width: 110,
        },
        {
          title: '代理商-授信余额',
          dataIndex: 'agentCreditBalance',
          key: 'agentCreditBalance',
          width: 110,
        },
        {
          title: '置换类型',
          dataIndex: 'exchangeType',
          key: 'exchangeType',
          width: 100,
        },
        {
          title: '治理类型',
          dataIndex: 'governanceType',
          key: 'governanceType',
          width: 80,
        },
        {
          title: '置换金额',
          dataIndex: 'exchangeAmount',
          key: 'exchangeAmount',
          width: 90,
        },
        {
          title: '转出',
          dataIndex: 'outCapitalType',
          key: 'outCapitalType',
          width: 110,
          customRender: ({ text }) => this.capitalTypeMap[text] || text || '-',
        },
        {
          title: '转入',
          dataIndex: 'inCapitalType',
          key: 'inCapitalType',
          width: 110,
          customRender: ({ text }) => this.capitalTypeMap[text] || text || '-',
        },
        {
          title: '今日消耗',
          dataIndex: 'todayCost',
          key: 'todayCost',
          width: 90,
        },
        // {
        //   title: '账户总余额',
        //   dataIndex: 'accountBalance',
        //   key: 'accountBalance',
        //   width: 100,
        // },
        // {
        //   title: '可转余额',
        //   dataIndex: 'transBalance',
        //   key: 'transBalance',
        //   width: 100,
        // },

        {
          title: '预付竞价余额',
          dataIndex: 'prepayBiddingBalance',
          key: 'prepayBiddingBalance',
          width: 90,
        },
        {
          title: '授信竞价余额',
          dataIndex: 'creditBiddingBalance',
          key: 'creditBiddingBalance',
          width: 90,
        },
        {
          title: '预付通用余额',
          dataIndex: 'prepayGeneralBalance',
          key: 'prepayGeneralBalance',
          width: 90,
        },
        {
          title: '授信通用余额',
          dataIndex: 'creditGeneralBalance',
          key: 'creditGeneralBalance',
          width: 90,
        },
        {
          title: '备注',
          dataIndex: 'remark',
          key: 'remark',
          width: 220,
          slots: { customRender: 'remark' },
        },
        {
          title: '执行结果',
          dataIndex: 'executeResult',
          key: 'executeResult',
          width: 220,
          slots: { customRender: 'executeResult' },
        },
        {
          title: '创建时间',
          dataIndex: 'createdTime',
          key: 'createdTime',
          width: 90,
        },
        {
          title: '状态',
          dataIndex: 'status',
          key: 'status',
          width: 80,
          fixed: 'right',
          slots: { customRender: 'status' },
        },
      ],
      // 执行治理弹窗
      governanceModalVisible: false,
      governanceResultText: '',
      governanceResultType: 'success',
      governanceForm: {
        agentIds: [],
        exchangeTypes: [],
        autoExecute: false,
      },
      agentOptions: [
        { agentId: '110761960254', label: '芦鸣-自走-全量-上海芦鸣网络科技有限公司-华东' },
        { agentId: '1806725962482905', label: '芦剧-嘉兴芦剧网络科技有限公司-抖音一组' },
        { agentId: '1794645328681035', label: '芦剧-嘉兴芦剧网络科技有限公司-张其超' },
      ],
      // 条件治理弹窗
      conditionModalVisible: false,
      conditionLoading: false,
      conditionAuditLoading: false,
      conditionAuditData: null,
      conditionAuditError: '',
      conditionForm: {
        agentId: null,
        exchangeType: undefined,
      },
      // 文件治理V2弹窗
      v2ModalVisible: false,
      v2Loading: false,
      v2ResultText: '',
      v2ResultType: 'success',
      v2Form: {
        accountBalanceFile: null,
        accountBalanceFileList: [],
        transferAddFile: null,
        transferAddFileList: [],
        transferRefundFile: null,
        transferRefundFileList: [],
        agentIds: [],
        exchangeTypes: [],
        autoExecute: false,
      },
    };
  },
  created() {
    this.getDataList();
  },
  methods: {
    getDataList() {
      if (this.tableLoading) return;
      this.tableLoading = true;
      const params = {
        ...this.filterConditions,
        current: this.tablePagination.current,
        size: this.tablePagination.pageSize,
      };
      // 清除空值
      Object.keys(params).forEach(key => {
        if (params[key] === '' || params[key] === null || params[key] === undefined) {
          delete params[key];
        }
      });
      queryFinancialGovernanceRecord(params).then(res => {
        if (res.code === 0) {
          const pageData = res.data || {};
          this.tableData = pageData.records || [];
          this.tablePagination.current = pageData.current || 1;
          this.tablePagination.pageSize = pageData.size || 30;
          this.tablePagination.total = pageData.total || 0;
        }
      }).catch(() => {
        this.tableData = [];
      }).finally(() => {
        this.tableLoading = false;
      });
    },
    onSearchBtnClick() {
      this.selectedRowKeys = [];
      this.selectedRows = [];
      this.tablePagination.current = 1;
      this.getDataList();
    },
    resetFilter() {
      this.selectedRowKeys = [];
      this.selectedRows = [];
      this.tablePagination.current = 1;
      this.filterConditions = {
        agentId: null,
        exchangeType: undefined,
        status: undefined,
        batchNo: '',
        minExchangeAmount: null,
        startDate: null,
        endDate: null,
      };
      this.getDataList();
    },
    onTableChange(pagination) {
      this.selectedRowKeys = [];
      this.selectedRows = [];
      this.tablePagination.current = pagination.current;
      this.tablePagination.pageSize = pagination.pageSize;
      this.getDataList();
    },
    onSelectChange(selectedRowKeys, selectedRows) {
      this.selectedRowKeys = selectedRowKeys;
      this.selectedRows = selectedRows;
    },
    // 导出治理记录
    exportRecord() {
      this.exportLoading = true;
      const params = {
        ...this.filterConditions,
      };
      Object.keys(params).forEach(key => {
        if (params[key] === '' || params[key] === null || params[key] === undefined) {
          delete params[key];
        }
      });
      exportGovernanceRecord(params).then(res => {
        const blob = new Blob([res], { type: 'application/vnd.ms-excel' });
        const objectUrl = URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = objectUrl;
        link.download = '资金治理记录.xlsx';
        link.click();
        URL.revokeObjectURL(objectUrl);
      }).catch(() => {
        message.error('导出失败');
      }).finally(() => {
        this.exportLoading = false;
      });
    },
    // 打开执行资金治理弹窗
    openGovernanceModal() {
      this.governanceForm = {
        agentIds: [],
        exchangeTypes: [],
        autoExecute: false,
      };
      this.governanceResultText = '';
      this.governanceResultType = 'success';
      this.governanceModalVisible = true;
    },
    // 确认执行资金治理
    handleGovernanceOk() {
      // 如果已有执行结果，点击"关闭"
      if (this.governanceResultText) {
        this.governanceModalVisible = false;
        this.governanceResultText = '';
        this.getDataList();
        return;
      }
      this.governanceLoading = true;
      const params = {
        agentIds: this.governanceForm.agentIds.length > 0 ? this.governanceForm.agentIds : null,
        exchangeTypes: this.governanceForm.exchangeTypes.length > 0 ? this.governanceForm.exchangeTypes : null,
        autoExecute: this.governanceForm.autoExecute,
      };
      financialGovernance(params).then(res => {
        if (res.code === 0) {
          const data = res.data;
          let msg = '资金治理执行完成';
          if (data && typeof data === 'string') {
            msg = data;
          } else if (data && data.message) {
            msg = data.message;
          }
          this.governanceResultText = msg;
          this.governanceResultType = 'success';
        } else {
          this.governanceResultText = '资金治理执行失败：' + (res.msg || '未知错误');
          this.governanceResultType = 'error';
        }
      }).catch(err => {
        this.governanceResultText = '资金治理请求异常：' + (err.msg || err.message || '网络错误');
        this.governanceResultType = 'error';
      }).finally(() => {
        this.governanceLoading = false;
      });
    },
    handleGovernanceCancel() {
      if (this.governanceResultText) {
        // 有结果时关闭并刷新
        this.governanceModalVisible = false;
        this.governanceResultText = '';
        this.getDataList();
      } else {
        this.governanceModalVisible = false;
      }
    },
    // 执行选中治理
    executeSelected() {
      if (this.selectedRows.length === 0) {
        message.warning('请选择需要执行的治理记录');
        return;
      }
      const ids = this.selectedRows.map(row => row.id);

      Modal.confirm({
        title: '确认执行',
        content: `即将执行 ${ids.length} 条资金治理任务，确认继续？`,
        onOk: () => {
          executeFinancialGovernance({ ids }).then(res => {
            if (res.code === 0) {
              message.success('执行成功');
            } else {
              message.warning('执行失败：' + (res.msg || '未知错误'));
            }
            this.selectedRowKeys = [];
            this.selectedRows = [];
            this.getDataList();
          }).catch(() => {
            message.error('执行请求失败');
          });
        },
      });
    },
    // 打开条件治理弹窗
    openConditionModal() {
      this.conditionForm = { agentId: null, exchangeType: undefined };
      this.conditionAuditData = null;
      this.conditionAuditError = '';
      this.conditionModalVisible = true;
    },
    // 条件治理字段变化时自动触发审核
    onConditionFieldChange() {
      this.conditionAuditData = null;
      this.conditionAuditError = '';
      if (this.conditionForm.agentId && this.conditionForm.exchangeType) {
        this.doConditionAudit();
      }
    },
    // 调用条件治理审核接口
    doConditionAudit() {
      this.conditionAuditLoading = true;
      this.conditionAuditData = null;
      this.conditionAuditError = '';
      auditFinancialGovernance({
        agentId: this.conditionForm.agentId,
        exchangeType: this.conditionForm.exchangeType,
      }).then(res => {
        if (res.code === 0) {
          this.conditionAuditData = res.data || {};
        } else {
          this.conditionAuditError = '审核失败：' + (res.msg || '未知错误');
        }
      }).catch(err => {
        this.conditionAuditError = '审核请求异常：' + (err.msg || err.message || '网络错误');
      }).finally(() => {
        this.conditionAuditLoading = false;
      });
    },
    // 确认执行条件治理
    handleConditionOk() {
      if (!this.conditionAuditData) return;
      this.conditionLoading = true;
      executeFinancialGovernance({
        agentId: this.conditionForm.agentId,
        exchangeType: this.conditionForm.exchangeType,
        batchNo: this.conditionAuditData.batchNo,
        ids: [],
      }).then(res => {
        if (res.code === 0) {
          message.success('条件治理执行成功');
          this.conditionModalVisible = false;
          this.getDataList();
        } else {
          message.warning('条件治理执行失败：' + (res.msg || '未知错误'));
        }
      }).catch(() => {
        message.error('条件治理执行请求失败');
      }).finally(() => {
        this.conditionLoading = false;
      });
    },
    handleConditionCancel() {
      this.conditionModalVisible = false;
    },
    // 打开文件治理V2弹窗
    openV2Modal() {
      this.v2Form = {
        accountBalanceFile: null,
        accountBalanceFileList: [],
        transferAddFile: null,
        transferAddFileList: [],
        transferRefundFile: null,
        transferRefundFileList: [],
        agentIds: [],
        exchangeTypes: [],
        autoExecute: false,
      };
      this.v2ResultText = '';
      this.v2ResultType = 'success';
      this.v2ModalVisible = true;
    },
    // 文件上传前拦截，阻止自动上传，限制类型和数量
    beforeV2Upload(file, fieldName) {
      const isExcel = file.name.endsWith('.xlsx') || file.name.endsWith('.xls');
      if (!isExcel) {
        message.error('仅支持上传 Excel 文件（.xlsx / .xls）');
        return false;
      }
      this.v2Form[fieldName] = file;
      this.v2Form[fieldName + 'List'] = [file];
      return false;
    },
    // 移除已选文件
    handleV2FileRemove(fieldName) {
      this.v2Form[fieldName] = null;
      this.v2Form[fieldName + 'List'] = [];
    },
    // 确认执行文件治理V2
    handleV2Ok() {
      if (this.v2ResultText) {
        this.v2ModalVisible = false;
        this.v2ResultText = '';
        this.getDataList();
        return;
      }
      if (!this.v2Form.accountBalanceFile) {
        message.warning('请上传账户余额文件');
        return;
      }
      this.v2Loading = true;
      const formData = new FormData();
      formData.append('accountBalanceFile', this.v2Form.accountBalanceFile);
      if (this.v2Form.transferAddFile) {
        formData.append('transferAddFile', this.v2Form.transferAddFile);
      }
      if (this.v2Form.transferRefundFile) {
        formData.append('transferRefundFile', this.v2Form.transferRefundFile);
      }
      if (this.v2Form.exchangeTypes.length > 0) {
        this.v2Form.exchangeTypes.forEach(t => formData.append('exchangeTypes', t));
      }
      formData.append('autoExecute', this.v2Form.autoExecute);
      financialGovernanceV2(formData).then(res => {
        if (res.code === 0) {
          const data = res.data;
          let msg = '文件治理执行完成';
          if (data && typeof data === 'string') {
            msg = data;
          } else if (data && data.message) {
            msg = data.message;
          }
          this.v2ResultText = msg;
          this.v2ResultType = 'success';
        } else {
          this.v2ResultText = '文件治理执行失败：' + (res.msg || '未知错误');
          this.v2ResultType = 'error';
        }
      }).catch(err => {
        this.v2ResultText = '文件治理请求异常：' + (err.msg || err.message || '网络错误');
        this.v2ResultType = 'error';
      }).finally(() => {
        this.v2Loading = false;
      });
    },
    handleV2Cancel() {
      if (this.v2ResultText) {
        this.v2ModalVisible = false;
        this.v2ResultText = '';
        this.getDataList();
      } else {
        this.v2ModalVisible = false;
      }
    },
  },
};
</script>

<style lang="less" scoped>
.funds-governance {
  display: flex;
  flex-direction: column;
  :deep(.filter_row) {
    flex-shrink: 0;
    padding-top: 0;
    padding-bottom: 6px;
  }
  .media-choice {
    flex-wrap: nowrap;
    .ant-form-item {
      margin-bottom: 6px;
    }
    .ant-col {
      .ant-select {
        width: 100%;
      }
    }
  }
  .table_wrapper {
    display: flex;
    flex-direction: column;
    flex: 1;
    min-height: 0;
    .table_operation {
      flex-shrink: 0;
      margin-bottom: 10px;
    }
    :deep(.governance_table) {
      flex: 1;
      min-height: 0;
      .ant-table-pagination {
        margin-bottom: 0 !important;
        margin-top: 12px;
      }
    }
  }
}
.cell-ellipsis {
  display: block;
  max-width: 150px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
</style>
